import { FamilyPlanTypes } from '../../common/services/package/package.model';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';

export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('familyPlanInfo', {
    component: 'fizyPaycellFamilyPlanInfo',
    parent: 'mainWrapper',
    resolve: {
      invoice: [
        '$q',
        'globalSpinner',
        ($q, globalSpinner: GlobalSpinnerService) => {
          globalSpinner.start();
          return globalSpinner.stop();
        }
      ],
      type: [() => { return FamilyPlanTypes.FAMILY; }]
    },
    url: '/family-plan-info'
  });

  $stateProvider.state('duoPlanInfo', {
    component: 'fizyPaycellFamilyPlanInfo',
    parent: 'mainWrapper',
    resolve: {
      invoice: [
        '$q',
        'globalSpinner',
        ($q, globalSpinner: GlobalSpinnerService) => {
          globalSpinner.start();
          return globalSpinner.stop();
        }
      ],
      type: [() => { return FamilyPlanTypes.DUO; }]
    },
    url: '/duo-plan-info'
  });
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-info/family-plan-info.routes.ts